import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="login-card">
          <div className="login-logo">
            <svg className="login-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#c84b2f" width="48" height="48" aria-hidden="true">
              <path d="M13 3l4 1.5-4 1.5V3z"/>
              <rect x="12.25" y="3" width="1.5" height="6"/>
              <rect x="7" y="9" width="10" height="4" rx="1"/>
              <polygon points="8.1,12.8 8.9,13.2 4.7,21.2 3.8,20.8"/>
              <polygon points="15.1,13.2 15.9,12.8 20.2,20.8 19.3,21.2"/>
              <polygon points="9.6,12.6 8.9,13.4 18.4,21.4 19.1,20.6"/>
              <polygon points="14.4,12.6 15.1,13.4 5.6,21.4 4.9,20.6"/>
              <rect x="2.5" y="21" width="4" height="1.5" rx="0.75"/>
              <rect x="17.5" y="21" width="4" height="1.5" rx="0.75"/>
            </svg>
            <h1>Outpost</h1>
            <p>by Survey Sherpa</p>
          </div>

          {error && <div className="error-banner">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

        <div className="login-footer">
          Need help? <a href="mailto:support@surveysherpa.com">Contact Support</a>
        </div>
      </div>
    </div>
  );
}
